import { render, staticRenderFns } from "./RoleTag.vue?vue&type=template&id=edf36210&"
import script from "./RoleTag.vue?vue&type=script&lang=js&"
export * from "./RoleTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports